export const notificationDetail = {
  createClientGroup: "Receive notifications when a team creates client group",
  createClient: "Receive notifications when a team creates client",
  editClientGroup: "Receive notifications when a team edits client group",
  editClient: "Receive notifications when a team edits client",
  deleteClientGroup: "Receive notifications when a team deletes client group",
  deleteClient: "Receive notifications when a team deletes client",
};
